import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import './HeaderPublicMenu.scss';
import { RoutePath } from '../../enums/RoutePath';
import { IPO_INTELLIGENCE_MARKETING_SITE_REQUEST_TRIAL_URL } from '../../constants/urls';

const HeaderPublicMenu: FunctionComponent = () => {
  return (
    <nav className="HeaderPublicMenu">
      <ul className="HeaderPublicMenu__list">
        <li className="HeaderPublicMenu__item HeaderPublicMenu__item--contact">
          <Link to={RoutePath.Contact}>Contact Us &gt;</Link>
        </li>

        <li className="HeaderPublicMenu__item">
          <Link to={RoutePath.Login} className="btn btn-sm btn-outline-primary text-uppercase">
            Login
          </Link>
        </li>

        <li className="HeaderPublicMenu__item">
          <a
            href={IPO_INTELLIGENCE_MARKETING_SITE_REQUEST_TRIAL_URL}
            className="HeaderPublicMenu__request btn btn-sm text-uppercase"
          >
            Request Access
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default HeaderPublicMenu;
